import { Editor } from 'slate';

export const getTextSelection = (editor: Editor): string => {
  const { selection } = editor;

  if (!selection) return '';

  return Editor.string(editor, selection);
};
